module.exports = __webpack_public_path__ + "static/img/tiktok.d761214.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tiktok.png
// module id = 6VmL
// module chunks = 1